import { render } from "./Accueil.vue?vue&type=template&id=ead694f4&scoped=true"
import script from "./Accueil.vue?vue&type=script&lang=js"
export * from "./Accueil.vue?vue&type=script&lang=js"

import "./Accueil.vue?vue&type=style&index=0&id=ead694f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ead694f4"

export default script